import { render } from "./UpdatepostForm.vue?vue&type=template&id=fa0026e6&scoped=true"
import script from "./UpdatepostForm.vue?vue&type=script&lang=js"
export * from "./UpdatepostForm.vue?vue&type=script&lang=js"

import "./UpdatepostForm.vue?vue&type=style&index=0&id=fa0026e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0026e6"]])

export default __exports__